// Configuration des images Pexels utilisées dans l'application
// Ces URLs doivent correspondre à celles utilisées dans la version web
import { getImagePath } from '../utils/imagePath';

export const pexelsImages = {
  carousel: [
    {
      // Image 1 - Graphiques financiers / Or / Métaux précieux
      url: 'https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
      // URL alternative si la première ne fonctionne pas
      fallbackUrl: '/assets/logo/1.webp',
      fallbackGradient: 'linear-gradient(135deg, #10b981 0%, #059669 50%, #10b981 100%)',
      title: 'Graphiques Financiers',
      subtitle: 'Analyse de Marché - Tendances Ascendantes'
    },
    {
      // Image 2 - Trading / Finance
      url: 'https://images.pexels.com/photos/6801648/pexels-photo-6801648.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
      fallbackUrl: '/assets/logo/2.webp',
      fallbackGradient: 'linear-gradient(135deg, #f97316 0%, #ea580c 50%, #f97316 100%)',
      title: 'Trading Professionnel',
      subtitle: 'Suivi en Temps Réel - Décisions Éclairées'
    },
    {
      // Image 3 - Analyse de performance
      url: 'https://images.pexels.com/photos/6801873/pexels-photo-6801873.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
      fallbackUrl: '/assets/logo/3.webp',
      fallbackGradient: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 50%, #2563eb 100%)',
      title: 'Analyse de Performance',
      subtitle: 'Barres de Données - Évolution Continue'
    },
    {
      // Image 4 - Interface moderne / Technologie
      url: 'https://images.pexels.com/photos/6801875/pexels-photo-6801875.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
      fallbackUrl: '/assets/logo/4.webp',
      fallbackGradient: 'linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #6366f1 100%)',
      title: 'Interface Moderne',
      subtitle: 'Technologie Avancée - Gestion Interactive'
    },
    {
      // Image 5 - Croissance / Expansion
      url: 'https://images.pexels.com/photos/6801876/pexels-photo-6801876.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop',
      fallbackUrl: '/assets/logo/5.webp',
      fallbackGradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 50%, #3b82f6 100%)',
      title: 'Croissance & Expansion',
      subtitle: 'Flux Financiers - Optimisation des Rendements'
    }
  ]
};

// Fonction pour obtenir l'URL de l'image avec fallback
// Utilise les images locales par défaut (identiques au site web), Pexels en fallback
export const getImageUrl = (imageConfig, usePexels = false) => {
  // Privilégier les images locales (identiques au site web)
  if (imageConfig.fallbackUrl) {
    return getImagePath(imageConfig.fallbackUrl);
  }
  // Fallback sur Pexels si l'image locale n'est pas disponible
  if (usePexels && imageConfig.url) {
    return imageConfig.url;
  }
  return getImagePath(imageConfig.fallbackUrl) || imageConfig.url;
};

// Fonction pour obtenir toutes les images du carrousel
// Par défaut, utilise les images locales (identiques au site web)
export const getCarouselImages = (usePexels = false) => {
  return pexelsImages.carousel.map(img => ({
    ...img,
    url: getImageUrl(img, usePexels)
  }));
};
